import {makeHFConfig} from 'src/components/Seasonal3';
import {Translator} from 'src/components/TranslationsContext';
import {VizConfig} from 'src/components/Viz/config';
import {SeriesType, Site} from 'src/lib/api/project';
import {Source, TimeAggregation} from 'src/lib/api/series';

/**
 * Release-model seasonal flow config for the regional report per-site forecast
 * chart. Thin wrapper over Seasonal3's makeHFConfig so palettes/styles stay in
 * sync with the Site Seasonal view.
 */
export function makeRegionalHFConfig(site: Site, t: Translator): VizConfig {
  const seasonalFlowSeriesType: SeriesType = site.seriesTypes.includes(
    SeriesType.FlowSeasonalRolling
  )
    ? SeriesType.FlowSeasonalRolling
    : SeriesType.FlowSeasonalRollingExtended;
  const timeAggregation: TimeAggregation = '1D';
  return makeHFConfig(
    site,
    timeAggregation,
    'rate',
    [],
    Source.HydroForecastSeasonal,
    seasonalFlowSeriesType,
    t
  );
}
